export enum PickupInboxPath {
  messageId = "messageId",
}

export type PickupInboxPathParams = {
  [PickupInboxPath.messageId]?: string;
};
